import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

class ProductService {
  async userList({ page = 0, limit = 10, search = null, category_uuid = null } = {}) {
    try {
      const params = { page, limit, search };
      if (category_uuid) {
        params.category_uuid = category_uuid;
      }
      const res = await axiosInstance.get(ENDPOINTS.PRODUCT.USER_LIST, { params });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async view(uuid) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.PRODUCT.VIEW(uuid));
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}

const productService = new ProductService();
export default productService;
